import type { LiveTruck, PositionFeedEvent } from '@chukua/common';
import { api } from '../../shared/shared.api';

export type { LiveTruck, PositionFeedEvent };

/** The server-sent events stream of trucks' new positions; a plain path, because `EventSource` does the request itself. */
export const LIVE_MAP_STREAM_URL = '/api/v1/tracking/stream';

/** Every truck with a known position and the trip it is on: not paged, like `GET /zones/map`, because a map of one page would be wrong. */
export function listLiveTrucks(): Promise<LiveTruck[]> {
  return api<LiveTruck[]>('/tracking/live-trucks');
}
